module.exports = new __parcel__URL__("pages-preview.fb1778e6.svg").toString();